/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { OfferApiConfiguration } from '../offer-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { PomProductPaymentDetailsResponseDto } from '../models/pom-product-payment-details-response-dto';


/**
 * the Product payment details API
 */
@Injectable({
  providedIn: 'root',
})
export class ProductPaymentDetailsService extends BaseService {
  constructor(
    config: OfferApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getPaymentDetails
   */
  static readonly GetPaymentDetailsPath = '/product/{productCode}/payment-details';

  /**
   * Get payment types and json additional parameters for product
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPaymentDetails()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPaymentDetails$Response(params: {
    productCode: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<PomProductPaymentDetailsResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, ProductPaymentDetailsService.GetPaymentDetailsPath, 'get');
    if (params) {
      rb.path('productCode', params.productCode, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PomProductPaymentDetailsResponseDto>;
      })
    );
  }

  /**
   * Get payment types and json additional parameters for product
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPaymentDetails$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPaymentDetails(params: {
    productCode: string;
  },
  context?: HttpContext

): Observable<PomProductPaymentDetailsResponseDto> {

    return this.getPaymentDetails$Response(params,context).pipe(
      map((r: StrictHttpResponse<PomProductPaymentDetailsResponseDto>) => r.body as PomProductPaymentDetailsResponseDto)
    );
  }

}
